export const DECREMENT_MAIN_COUNTER = 'DECREMENT_MAIN_COUNTER'
export const INCREMENT_MAIN_COUNTER = 'INCREMENT_MAIN_COUNTER'
export const NEXT_STEP = 'NEXT_STEP'
export const PREV_STEP = 'PREV_STEP'
export const GO_STEP = 'GO_STEP'
export const CHANGE_LOGIN = 'CHANGE_LOGIN'
export const LOGOUT = 'LOGOUT'
export const LOGIN = 'LOGIN'
export const SAVE_CHECKIN_INFO = 'SAVE_CHECKIN'
export const CHANGE_MENU = 'CHANGE_MENU'
export const CHANGE_CAMPAIGN = 'CHANGE_CAMPAIGN'
export const CHANGE_ADBLOCK = 'CHANGE_ADBLOCK'
export const SET_SYSTEM_NAME = 'SET_SYSTEM_NAME'
export const SET_SYSTEM_VALUE = 'SET_SYSTEM_VALUE'
export const SET_NOTIFICATION = 'SET_NOTIFICATION'
export const CLEAR_NOTIFICATION = 'CLEAR_NOTIFICATION'
export const SET_CAMPAIGN_FORM = 'SET_CAMPAIGN_FORM'
export const SET_SYSTEM_URL_COUNTRY = 'SET_SYSTEM_URL_COUNTRY'



// WEBPACK FOOTER //
// ./src/vuex/mutation-types.js